import { captureException } from './sentry';

export enum ErrorMessage {
  CHAT_DISABLED = 'Kustomer Chat is disabled in your org settings. Initialization will not continue.',
}

export interface ErrorProps {
  message?: string;
  tags?: Record<string, any>;
}

export const handleError = (error, { message, tags }: ErrorProps = {}) => {
  console.error(message, error);
  if (error.message === ErrorMessage.CHAT_DISABLED) {
    return undefined;
  }
  return captureException(error, {
    tags: {
      errorBoundary: false,
      ...tags,
    },
  });
};
